import React from 'react';
import LightningIcon from '../../../../../../../assets/svg/solo/circle-lightning.svg';
import style from './empty-message.module.scss';

type Props = {
	onAdd: () => void;
	lock: boolean;
};

export function EmptyMessage(props: Props) {
	const { onAdd, lock } = props;
	return (
		<div className={style.emptyMessage}>
			<img src={LightningIcon} alt="no message" />
			<p>You have not added any messages yet</p>
			<button disabled={lock} onClick={onAdd}>
				Add
			</button>
		</div>
	);
}
